import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { CourtSystem } from '@ftr/contracts/api/court-system'
import { RemoteData, ScreenSizeService } from '@ftr/foundation'
import { LogoSize, LogoTheme } from '@ftr/ui-core'
import { UserState } from '@ftr/ui-user'
import { Store } from '@ngxs/store'
import { Observable, distinctUntilChanged } from 'rxjs'

@Component({
  selector: 'ftr-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HeaderComponent implements OnInit {
  @Input() logoData: RemoteData<string | undefined>

  isLoggedIn$: Observable<boolean>
  currentCourtSystem$: Observable<CourtSystem>

  readonly logoThemes = LogoTheme
  readonly logoSizes = LogoSize

  constructor(
    private readonly store: Store,
    protected readonly screenSizeService: ScreenSizeService,
  ) {}

  ngOnInit(): void {
    this.isLoggedIn$ = this.store.select(UserState.isLoggedIn).pipe(distinctUntilChanged())
  }

  get hasNoPersonalizedLogo(): boolean {
    return (
      this.logoData.isCompleted() &&
      !(this.logoData.isSuccess() && this.logoData._data && this.logoData._data.length > 1)
    )
  }

  get logoUrl(): string | undefined {
    return this.logoData.isSuccess() ? this.logoData._data : undefined
  }
}
